"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var linkClick_1 = require("./linkClick");
var AILinkClick_1 = require("./AILinkClick");
var quizClick_1 = require("./quizClick");
var applicationClick_1 = require("./applicationClick");
var paymentClick_1 = require("./paymentClick");
var confDropdownClick_1 = require("./confDropdownClick");
var confFilterClick_1 = require("./confFilterClick");
var toggleClick_1 = require("./toggleClick");
var courseClick_1 = require("./courseClick");
var eventClick_1 = require("./eventClick");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.LinkInteractionEventNames.ApplicationClick] = applicationClick_1.applicationClick,
    _a[analytics_layer_1.LinkInteractionEventNames.LinkClick] = linkClick_1.linkClick,
    _a[analytics_layer_1.LinkInteractionEventNames.AILinkClick] = AILinkClick_1.AILinkClick,
    _a[analytics_layer_1.LinkInteractionEventNames.QuizClick] = quizClick_1.quizClick,
    _a[analytics_layer_1.LinkInteractionEventNames.PaymentClick] = paymentClick_1.paymentClick,
    _a[analytics_layer_1.LinkInteractionEventNames.ConfDropdownClick] = confDropdownClick_1.confDropdownClick,
    _a[analytics_layer_1.LinkInteractionEventNames.ConfFilterClick] = confFilterClick_1.confFilterClick,
    _a[analytics_layer_1.LinkInteractionEventNames.ToggleClick] = toggleClick_1.toggleClick,
    _a[analytics_layer_1.LinkInteractionEventNames.CourseClick] = courseClick_1.courseClick,
    _a[analytics_layer_1.LinkInteractionEventNames.EventClick] = eventClick_1.eventClick,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
